const session = "napschools";
export default session;
